module.exports = __webpack_public_path__ + "static/OurValues1-b0aeef8ed9ad1b6438b87d0a22bda74c.png";